<template>
  <ThePage>
    <template #pageTitle>
      {{ i18n(translations.pageTitle) }}
    </template>
    <template #pageContent>
      <RevCard class="mx-auto grid max-w-[1200px] grid-cols-12 gap-24 p-24">
        <template v-if="status === 'pending'">
          <div class="col-span-12 flex justify-center py-48">
            <RevSpinner />
          </div>
        </template>
        <template v-else>
          <Stepper class="col-span-4" />
          <NuxtPage class="col-span-8 px-24" />
        </template>
      </RevCard>
    </template>
  </ThePage>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevSpinner } from '@ds/components/Spinner'

import ThePage from '~/components/ThePage/ThePage.vue'
import { useKybData } from '~/scopes/kyb/composables/useKybData'

import translations from './Index.translations'
import Stepper from './components/Stepper/Stepper.vue'

const i18n = useI18n()

const { fetchKybData, status } = useKybData()
await fetchKybData()
</script>
